import { redirect } from "@sveltejs/kit";

import { redirectOr404 } from "$lib/docs/redirects";
import type { PageLoad } from "./$types";

export const prerender = "auto";

export const load: PageLoad = async ({ params }) => {
  let module;
  if (params.id) {
    try {
      module = await import(`../../../../lib/docs/guide/${params.id}.svx`);
    } catch (_) {
      // If /docs/guide/ex/A does not exist, go to /docs/examples/A.
      // If /docs/guide/A does not exist, go to /docs/examples/A.
      if (params.id.startsWith("ex/")) {
        redirect(302, `/docs/examples/${params.id.substring(3)}`);
      } else {
        redirectOr404(`guide/${params.id}`);
      }
    }
  } else {
    module = await import("$lib/docs/guide/intro.svx");
  }
  return {
    content: module.default,
    ogTitle: module.metadata.meta.title,
    ogDescription: module.metadata.meta.description,
    ogImageUrl:
      "https://modal.com/docs/social-image.png?" +
      new URLSearchParams({
        title: module.metadata.meta.title,
        socialType: "docs",
      }),
    title: module.metadata.meta.title + " | Modal Docs",
  };
};
